import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

export default React.memo(({ sentencia, handleClick }) => (
  <tr onClick={() => handleClick(sentencia.dni)} className="pointer">
    <td className="text-left">{sentencia.year}</td>
    <td className="field-nombre">{sentencia.candidato}</td>
    <td className="text-left">{sentencia.cargo}</td>
    <td className="text-left">{sentencia.region}</td>
    <td className="text-left">{sentencia.decision}</td>
    <td className="text-left">{sentencia.estado}</td>
  
    <td className="text-left"></td>
    <td>
      <FontAwesomeIcon icon={faSearchPlus} />
    </td>
  </tr>
));
